// Chère Michelle — petits comportements du thème (sans dépendance)
(function () {
  // menu mobile
  const burger = document.querySelector('.burger');
  if (burger) burger.addEventListener('click', () => {
    const m = document.getElementById('menu-mobile');
    const on = m.classList.toggle('on');
    burger.setAttribute('aria-expanded', on);
  });

  const euro = (cents) => (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',00', '') + ' €';

  document.querySelectorAll('[data-produit]').forEach((root) => {
    const data = JSON.parse(root.querySelector('script[data-produit-json]').textContent);
    const form = root.querySelector('form[action*="/cart/add"]');
    const idInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    const btn = form.querySelector('[type="submit"]');
    const prix = root.querySelector('[data-prix]');
    const big = root.querySelector('[data-big]');
    const thumbs = root.querySelectorAll('[data-thumb]');
    const legends = root.querySelectorAll('[data-option-label]');

    // galerie
    const montrer = (src, alt) => { if (big && src) { big.src = src; big.srcset = ''; if (alt) big.alt = alt; } };
    thumbs.forEach((t) => t.addEventListener('click', () => {
      montrer(t.dataset.src, t.dataset.alt);
      thumbs.forEach((x) => x.classList.toggle('on', x === t));
    }));

    // variantes
    const choix = () => Array.from(root.querySelectorAll('.opt')).map((fs) => {
      const c = fs.querySelector('input:checked'); return c ? c.value : null;
    });
    const trouver = (vals) => vals.length === 0 ? data.variants[0] : data.variants.find((v) => v.options.every((o, i) => o === vals[i]));
    const lotPrix = root.querySelector('[data-prix-lot]');
    const maj = () => {
      const vals = choix();
      root.querySelectorAll('.opt').forEach((fs, i) => {
        const lab = fs.querySelector('[data-option-label]'); if (lab) lab.textContent = vals[i] || '';
        // griser les combinaisons indisponibles
        fs.querySelectorAll('input').forEach((inp) => {
          const test = vals.slice(); test[i] = inp.value;
          const v = trouver(test); inp.classList.toggle('indispo', !v || !v.available);
        });
      });
      const v = trouver(vals);
      if (!v) { btn.disabled = true; btn.textContent = btn.dataset.indispo; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.ajouter : btn.dataset.epuise;
      if (prix) prix.innerHTML = euro(v.price) + (v.compare_at_price > v.price ? ' <s>' + euro(v.compare_at_price) + '</s>' : '') + prix.dataset.suffixe;
      if (v.featured_image) montrer(v.featured_image.src + (v.featured_image.src.includes('?') ? '&' : '?') + 'width=1200', v.featured_image.alt);
      if (lotPrix) lotPrix.textContent = euro(v.price);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      const st = document.querySelector('[data-sticky-prix]'); if (st) st.textContent = euro(v.price);
    };
    root.querySelectorAll('.opt input').forEach((i) => i.addEventListener('change', maj));

    root.querySelectorAll('[data-qte-btn]').forEach((b) => b.addEventListener('click', () => {
      qtyInput.value = Math.max(1, (+qtyInput.value || 1) + (+b.dataset.qteBtn));
    }));

    // ajout au panier sans quitter la page, puis compteur
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const err = form.querySelector('.erreur'); if (err) err.textContent = '';
      btn.disabled = true;
      try {
        const r = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message);
        const c = await (await fetch(window.routes.cart_url + '.js')).json();
        document.querySelectorAll('[data-cart-count]').forEach((n) => n.textContent = c.item_count);
        btn.textContent = btn.dataset.ajoute;
        if (window.cmTiroir) { window.cmTiroir(true); setTimeout(() => { btn.textContent = btn.dataset.ajouter; btn.disabled = false; }, 1200); }
        else setTimeout(() => { location.href = window.routes.cart_url; }, 500);
      } catch (x) {
        if (err) err.textContent = x.message || 'Erreur, réessaie.';
        btn.disabled = false;
      }
    });

    maj();

    // barre collante
    const st = document.getElementById('sticky');
    if (st) {
      const cible = form.querySelector('.qte');
      const obs = new IntersectionObserver(([en]) => st.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0));
      obs.observe(cible);
      st.querySelector('button').addEventListener('click', () => form.requestSubmit());
    }
  });

  // complète ton lot : ajout d'une autre bague sans quitter la page
  document.querySelectorAll('[data-lot-form]').forEach((f) => f.addEventListener('submit', async (e) => {
    e.preventDefault();
    const b = f.querySelector('button'); const txt = b.textContent; b.disabled = true;
    try {
      const r = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) });
      if (!r.ok) throw new Error();
      const c = await (await fetch(window.routes.cart_url + '.js')).json();
      document.querySelectorAll('[data-cart-count]').forEach((n) => n.textContent = c.item_count);
      b.textContent = b.dataset.ajoute;
      if (window.cmTiroir) window.cmTiroir(true); else if (window.cmMiniPanier) window.cmMiniPanier(true);
      setTimeout(() => { b.textContent = txt; b.disabled = false; }, 2000);
    } catch (x) { b.textContent = 'Erreur'; setTimeout(() => { b.textContent = txt; b.disabled = false; }, 2000); }
  }));

  // compose ton lot : la pastille change la photo de la bague
  document.querySelectorAll('.lot-pas input').forEach((i) => i.addEventListener('change', () => {
    const img = i.closest('.lot-c').querySelector('.lot-img img');
    if (img && i.dataset.img) { img.src = i.dataset.img; img.srcset = ''; }
  }));

  // autres bagues : flèches du slider
  document.querySelectorAll('[data-reco-rail]').forEach((rail) => {
    const fl = rail.closest('section').querySelectorAll('[data-reco-fl]');
    const etat = () => {
      if (!fl.length) return;
      fl[0].disabled = rail.scrollLeft < 5;
      fl[1].disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 5;
    };
    fl.forEach((b) => b.addEventListener('click', () => rail.scrollBy({ left: +b.dataset.recoFl * rail.clientWidth * 0.8 })));
    rail.addEventListener('scroll', etat, { passive: true });
    window.addEventListener('resize', etat);
    etat();
  });

  // fiche produit : agrandir la photo
  document.querySelectorAll('[data-zoom]').forEach((ph) => ph.addEventListener('click', () => {
    const d = document.getElementById('zoom-photo'); const big = ph.querySelector('img');
    if (!d || !big) return;
    const im = d.querySelector('img'); im.src = big.src.replace(/width=\d+/, 'width=1800'); im.alt = big.alt;
    d.showModal();
  }));
  document.querySelectorAll('dialog').forEach((d) => d.addEventListener('click', (e) => { if (e.target === d) d.close(); }));

  // mini-panier au survol de « Panier »
  const zone = document.querySelector('[data-mp-zone]');
  if (zone) {
    const mp = zone.querySelector('[data-mp]');
    const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const img = (u) => u ? u + (u.includes('?') ? '&' : '?') + 'width=140' : '';
    let timer;
    const dessiner = (c) => {
      if (!c.item_count) {
        mp.innerHTML = '<div class="mp-t"><span>Ton panier</span></div><div class="mp-vide">Ton panier est vide.<br><a href="' + mp.dataset.collection + '">Découvrir les bagues</a></div>';
        return;
      }
      const lignes = c.items.map((it) => '<div class="mp-l">' +
        '<a href="' + it.url + '">' + (it.image ? '<img src="' + img(it.image) + '" alt="" width="58" height="58" loading="lazy">' : '') + '</a>' +
        '<div><a class="n" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
        (it.variant_title ? '<div class="v">' + esc(it.variant_title) + '</div>' : '') +
        '<div class="mp-q"><button type="button" data-mp-q="' + it.key + '" data-n="' + (it.quantity - 1) + '" aria-label="Retirer une bague">–</button><span>' + it.quantity + '</span>' +
        '<button type="button" data-mp-q="' + it.key + '" data-n="' + (it.quantity + 1) + '" aria-label="Ajouter une bague">+</button>' +
        '<button type="button" class="mp-x" data-mp-q="' + it.key + '" data-n="0">Retirer</button></div></div>' +
        '<div class="p">' + euro(it.original_line_price) + '</div></div>').join('');
      const n = c.item_count, r2 = mp.dataset.r2, r3 = mp.dataset.r3;
      let encore = '';
      if (n === 1 && +r2) encore = 'Ajoute une 2e bague : -' + r2 + ' % sur tout ton panier.';
      else if (n === 2 && +r3) encore = 'Ajoute une 3e bague : -' + r3 + ' % sur tout ton panier.';
      const off = c.original_total_price - c.total_price;
      const titres = (c.cart_level_discount_applications || []).map((d) => d.value_type === 'percentage' ? 'Offre -' + Math.round(+d.value) + ' %' : esc(d.title)).join(', ') || 'Remise';
      mp.innerHTML = '<div class="mp-t"><span>Ton panier</span><span>' + n + ' bague' + (n > 1 ? 's' : '') + '</span></div>' +
        '<div class="mp-lignes">' + lignes + '</div>' +
        (off > 0 ? '<div class="mp-off"><span>' + titres + '</span><span>-' + euro(off) + '</span></div>' : '') +
        '<div class="mp-tot"><span>Total</span><span>' + (off > 0 ? '<s>' + euro(c.original_total_price) + '</s>' : '') + euro(c.total_price) + '</span></div>' +
        '<div class="mp-kl">Ou 3 × ' + euro(Math.floor(c.total_price / 3)) + ' sans frais avec <span class="k">Klarna.</span></div>' +
        (encore ? '<div class="mp-encore">' + encore + '</div>' : '') +
        '<div class="mp-btns"><a href="' + window.routes.cart_url + '">Voir le panier</a><a class="p" href="' + mp.dataset.checkout + '">Payer</a></div>';
    };
    const charger = async () => { try { dessiner(await (await fetch(window.routes.cart_url + '.js')).json()); } catch (x) {} };
    // quantité et retrait directement dans l'aperçu
    const st = document.createElement('style');
    st.textContent = '.mp-q{display:flex;align-items:center;gap:6px;margin-top:4px}.mp-q button{background:none;border:1px solid #23212033;width:22px;height:22px;cursor:pointer;font:13px \'Space Mono\',monospace;color:#151515;line-height:1}.mp-q span{font:12px \'Space Mono\',monospace;min-width:14px;text-align:center}.mp-q .mp-x{border:0;width:auto;text-decoration:underline;font-size:11px;margin-left:6px}.mp.maj{opacity:.6;pointer-events:none}';
    document.head.appendChild(st);
    mp.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-mp-q]'); if (!b) return;
      e.preventDefault(); mp.classList.add('maj');
      try {
        const r = await fetch((window.routes.root_url || '/') + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: b.dataset.mpQ, quantity: +b.dataset.n }) });
        const c = await r.json();
        dessiner(c);
        document.querySelectorAll('[data-cart-count]').forEach((x) => x.textContent = c.item_count);
        document.dispatchEvent(new CustomEvent('cm:panier'));
      } catch (x) {}
      mp.classList.remove('maj');
    });
    window.cmMiniPanier = async (ouvrir) => { await charger(); if (ouvrir && matchMedia('(hover:hover) and (min-width:761px)').matches) { zone.classList.add('on'); clearTimeout(timer); timer = setTimeout(() => zone.classList.remove('on'), 3000); } };
    zone.addEventListener('mouseenter', () => { clearTimeout(timer); charger(); zone.classList.add('on'); });
    zone.addEventListener('mouseleave', () => { clearTimeout(timer); timer = setTimeout(() => zone.classList.remove('on'), 200); });
    zone.addEventListener('focusin', () => { charger(); zone.classList.add('on'); });
    zone.addEventListener('focusout', (e) => { if (!zone.contains(e.relatedTarget)) zone.classList.remove('on'); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') zone.classList.remove('on'); });
  }

  // panier : boutons - / +
  document.querySelectorAll('[data-panier-qte]').forEach((b) => b.addEventListener('click', () => {
    const inp = b.parentElement.querySelector('input');
    inp.value = Math.max(0, (+inp.value || 0) + (+b.dataset.panierQte));
    inp.form.submit();
  }));

  // tiroir panier : s'ouvre après chaque ajout, montre le palier de remise et propose d'autres bagues
  (function () {
    const mp = document.querySelector('[data-mp]');
    const r2 = +(mp && mp.dataset.r2) || 0, r3 = +(mp && mp.dataset.r3) || 0;
    const collUrl = (mp && mp.dataset.collection) || '/collections/all';
    const checkout = (mp && mp.dataset.checkout) || '/checkout';
    const racine = (window.routes && window.routes.root_url) || '/';
    const esc = (x) => String(x || '').replace(/[&<>"]/g, (k) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[k]));
    const img = (u, w) => u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '';
    const pastille = (k) => ({ 'Doré': '#D8B25A', 'Or rose': '#D9A08F', 'Noir': '#222', 'Trois ors': 'linear-gradient(90deg,#D8B25A 33%,#C9C9C9 33% 66%,#D9A08F 66%)' })[k] || '#C9C9C9';

    const t = document.createElement('div');
    t.className = 'tir'; t.setAttribute('aria-hidden', 'true');
    t.innerHTML = '<div class="tir-fond" data-tir-fermer></div><aside class="tir-p" role="dialog" aria-modal="true" aria-label="Ton panier">' +
      '<div class="tir-h"><span data-tir-titre>Ton panier</span><button type="button" class="tir-x" data-tir-fermer aria-label="Fermer le panier">×</button></div>' +
      '<div class="tir-c" data-tir-c></div></aside>' +
      '<style>.tir-o{display:inline-flex;align-items:center;gap:6px;margin:6px 8px 0 0;font:11px \'Space Mono\',monospace;text-transform:uppercase}' +
      '.tir-o select{font:12px \'Space Mono\',monospace;border:1px solid var(--noir);background:var(--blanc);color:var(--noir);padding:3px 22px 3px 6px;cursor:pointer;-webkit-appearance:none;appearance:none;' +
      'background-image:linear-gradient(45deg,transparent 50%,#151515 50%),linear-gradient(135deg,#151515 50%,transparent 50%);background-position:calc(100% - 10px) 50%,calc(100% - 6px) 50%;background-size:4px 4px;background-repeat:no-repeat}' +
      '.tir-l .opts{display:flex;flex-wrap:wrap}.tir-l.maj{opacity:.5;pointer-events:none}' +
      '.tir-off{color:#2F6B3F;font:700 13px \'Manrope\',sans-serif}.tir-livr{text-align:center;opacity:1;margin-top:14px}.tir-livr b{display:block;text-transform:uppercase}' +
      '.tir-guide{margin-top:10px;font-size:13px}.tir-guide summary{cursor:pointer;font:11px \'Space Mono\',monospace;text-decoration:underline;text-transform:uppercase}' +
      '.tir-guide p{margin:8px 0}.tir-guide table{width:100%;border-collapse:collapse;font:12px \'Space Mono\',monospace}.tir-guide td,.tir-guide th{text-align:left;padding:4px;border-bottom:1px dotted var(--dots)}' +
      '.tir-pcs{display:flex;gap:7px;margin-top:7px}.tir-pcs button{width:16px;height:16px;border-radius:50%;border:1px solid #15151533;padding:0;cursor:pointer}.tir-pcs button.on{outline:1.5px solid #151515;outline-offset:2px}.tir-pcs button[disabled]{opacity:.25;cursor:default}' +
      '.tir-kl{font-size:12px;margin-top:6px;text-align:right}.tir-kl .k,.mp-kl .k{background:#FFB3C7;color:#0B051D;font:800 10px \'Inter Tight\',sans-serif;padding:1px 6px;border-radius:4px}.mp-kl{font-size:11.5px;text-align:right;margin-top:2px}' +
      '.tir-code{display:grid;grid-template-columns:1fr auto;gap:6px;margin-top:14px}.tir-code input{border:1.5px solid #151515;padding:9px 10px;font:13px \'Manrope\',sans-serif;text-transform:uppercase;min-width:0}.tir-code button{background:#151515;color:#fff;border:0;padding:0 14px;font:700 11px \'Space Mono\',monospace;text-transform:uppercase;cursor:pointer}' +
      '.tir-code-err{font-size:12px;color:#A9553A;margin-top:6px}.tir-x2{background:none;border:0;font:11px \'Space Mono\',monospace;text-decoration:underline;cursor:pointer;color:inherit;margin-left:6px;padding:0}' +
      '.tir-eco{display:flex;justify-content:space-between;margin-top:6px;font:700 13px \'Manrope\',sans-serif;color:#2F6B3F;border-top:1px dotted #23212033;padding-top:6px}' +
      '.tir-pay{display:flex;justify-content:center;flex-wrap:wrap;gap:6px;margin-top:10px}.tir-pay svg{height:22px;width:auto}</style>';
    document.body.appendChild(t);
    const c = t.querySelector('[data-tir-c]'), titre = t.querySelector('[data-tir-titre]');

    let catalogue = null;
    const produits = async () => {
      if (catalogue) return catalogue;
      try { catalogue = (await (await fetch(collUrl.replace(/\/$/, '') + '/products.json?limit=50')).json()).products || []; } catch (x) { catalogue = []; }
      return catalogue;
    };
    const fiches = {};
    const fiche = async (h) => {
      if (!fiches[h]) fiches[h] = fetch(racine + 'products/' + h + '.js').then((r) => r.json()).catch(() => null);
      return fiches[h];
    };
    const jours = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' }).format(d); };
    const options = (it, p) => {
      if (!p || it.product_has_only_default_variant || p.variants.length < 2) return it.variant_title ? '<div class="v">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="opts">' + p.options.map((o, i) => {
        const vals = o.values || [];
        const cur = (it.options_with_values[i] || {}).value;
        const dispo = (v) => { const test = (it.options_with_values || []).map((x) => x.value); test[i] = v; return p.variants.some((x) => x.available && x.options.every((y, j) => y === test[j])); };
        // la couleur en pastilles, comme sur la fiche
        if (/couleur/i.test(o.name || o)) {
          const tri = vals.slice().sort((a, b) => (b === 'Doré') - (a === 'Doré'));
          return '<span class="tir-pcs" data-tir-var="' + it.key + '" data-i="' + i + '" data-h="' + esc(it.handle) + '" data-qte="' + it.quantity + '" data-val="' + esc(cur) + '">' +
            tri.map((v) => '<button type="button" data-tir-pc="' + esc(v) + '" title="' + esc(v) + '" aria-label="' + esc(v) + '" class="' + (v === cur ? 'on' : '') + '"' + (dispo(v) ? '' : ' disabled') + ' style="background:' + pastille(v) + '"></button>').join('') + '</span>';
        }
        return '<label class="tir-o">' + esc(o.name || o) + '<select data-tir-var="' + it.key + '" data-i="' + i + '" data-h="' + esc(it.handle) + '" data-qte="' + it.quantity + '" aria-label="' + esc(o.name || o) + '">' +
          vals.map((v) => {
            const test = (it.options_with_values || []).map((x) => x.value); test[i] = v;
            const ok = p.variants.some((x) => x.available && x.options.every((y, j) => y === test[j]));
            return '<option value="' + esc(v) + '"' + (test[i] === (it.options_with_values[i] || {}).value ? ' selected' : '') + (ok ? '' : ' disabled') + '>' + esc(v) + (ok ? '' : ' (épuisée)') + '</option>';
          }).join('') + '</select></label>';
      }).join('') + '</div>';
    };
    const fermer = () => { t.classList.remove('on'); t.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('tir-ouvert'); };
    t.addEventListener('click', (e) => { if (e.target.closest('[data-tir-fermer]')) fermer(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && t.classList.contains('on')) fermer(); });

    const dessiner = async (cart, ajoute) => {
      const n = cart.item_count;
      titre.textContent = ajoute ? 'Ajoutée à ton panier ✓' : 'Ton panier';
      if (!n) { c.innerHTML = '<div class="tir-vide">Ton panier est vide.<a class="tir-b p" href="' + collUrl + '">Découvrir les bagues</a></div>'; return; }
      let msg = '';
      if (n === 1 && r2) msg = 'Ajoute <b>1 bague</b> et économise <b>' + r2 + ' %</b> sur tout ton panier.';
      else if (n === 2 && r3) msg = 'Ajoute <b>1 bague</b> et passe à <b>-' + r3 + ' %</b> sur tout ton panier.';
      else if (n >= 3 && r3) msg = 'Tu profites de <b>-' + r3 + ' %</b> sur tout ton panier.';
      const pal = msg ? '<div class="tir-pal"><p>' + msg + '</p><div class="tir-barre">' +
        ['1 bague', '2 bagues · -' + r2 + ' %', '3 bagues · -' + r3 + ' %'].map((l, i) => '<span class="' + (n > i ? 'on' : '') + '">' + l + '</span>').join('') + '</div></div>' : '';
      const ps = {}; await Promise.all(cart.items.map(async (it) => { ps[it.key] = it.product_has_only_default_variant ? null : await fiche(it.handle); }));
      const lignes = cart.items.map((it) => '<div class="tir-l">' +
        '<a href="' + it.url + '">' + (it.image ? '<img src="' + img(it.image, 160) + '" alt="' + esc(it.product_title) + '" width="72" height="72">' : '') + '</a>' +
        '<div><a class="n" href="' + it.url + '">' + esc(it.product_title) + '</a>' + options(it, ps[it.key]) +
        '<div class="q"><button type="button" data-tir-q="' + it.key + '" data-n="' + (it.quantity - 1) + '" aria-label="Retirer une bague">–</button><span>' + it.quantity + '</span>' +
        '<button type="button" data-tir-q="' + it.key + '" data-n="' + (it.quantity + 1) + '" aria-label="Ajouter une bague">+</button></div></div>' +
        '<div class="p">' + euro(it.original_line_price) + '</div></div>').join('');
      const off = cart.original_total_price - cart.total_price;
      // détail des économies : l'offre automatique d'un côté, chaque code de l'autre
      const parCode = {};
      cart.items.forEach((it) => (it.line_level_discount_allocations || []).forEach((a) => {
        const d = a.discount_application || {}; if (d.type !== 'discount_code') return;
        parCode[d.title] = (parCode[d.title] || 0) + a.amount;
      }));
      (cart.cart_level_discount_applications || []).forEach((d) => { if (d.type === 'discount_code') parCode[d.title] = (parCode[d.title] || 0) + d.total_allocated_amount; });
      const auto = (cart.cart_level_discount_applications || []).filter((d) => d.type !== 'discount_code').reduce((s2, d) => s2 + d.total_allocated_amount, 0);
      const codes = (cart.discount_codes || []);
      const refuse = codes.filter((x) => !x.applicable).map((x) => esc(x.code));
      const lignesRemise = (auto > 0 ? '<div class="tir-off"><span>Offre -' + (n >= 3 ? r3 : r2) + ' %</span><span>-' + euro(auto) + '</span></div>' : '') +
        Object.keys(parCode).map((k) => '<div class="tir-off"><span>Code ' + esc(k) + ' <button type="button" class="tir-x2" data-tir-sans="' + esc(k) + '">Retirer</button></span><span>-' + euro(parCode[k]) + '</span></div>').join('') +
        (off > 0 ? '<div class="tir-eco"><span>Tu économises</span><span>' + euro(off) + '</span></div>' : '');
      const champ = '<form class="tir-code" data-tir-code><label class="visually-hidden" for="tir-code-in">Code de réduction</label><input id="tir-code-in" name="code" placeholder="Code de réduction" autocomplete="off"><button type="submit">Appliquer</button></form>' +
        (refuse.length ? '<p class="tir-code-err">Le code ' + refuse.join(', ') + ' ne s\'applique pas à ton panier.</p>' : '');
      const tot = champ + lignesRemise +
        '<div class="tir-tot"><span>Total</span><span>' + (off > 0 ? '<s>' + euro(cart.original_total_price) + '</s>' : '') + euro(cart.total_price) + '</span></div>' +
        '<div class="tir-kl">Ou 3 × ' + euro(Math.floor(cart.total_price / 3)) + ' sans frais avec <span class="k">Klarna.</span></div>' +
        '';
      const pay = document.querySelector('.paiements');
      const btns = '<div class="tir-btns"><a class="tir-b p" href="' + checkout + '">Payer · ' + euro(cart.total_price) + '</a>' +
        (pay ? '<div class="tir-pay">' + pay.innerHTML + '</div>' : '') +
        '<div class="tir-livr"><b>Livraison gratuite en France</b>Ta commande arrive entre le ' + jours(5) + ' et le ' + jours(12) + '</div>' +
        '<button type="button" class="tir-b" data-tir-fermer>Continuer mes achats</button></div>';
      const aTaille = cart.items.some((it) => ps[it.key] && ps[it.key].options.some((o) => /taille/i.test(o.name || o)));
      const guide = aTaille ? '<details class="tir-guide"><summary>Trouver ma taille</summary><p>Enroule un fil autour de ton doigt, marque le tour, puis mesure-le. Entre deux tailles, prends la plus grande : l\'anneau doit pouvoir tourner.</p><table><tr><th>Taille</th><th>Tour de doigt</th></tr>' +
        [['49', '49,3'], ['52', '51,9'], ['54', '54,4'], ['57', '57,0'], ['59', '59,5'], ['62', '62,1'], ['64', '64,6'], ['67', '67,2'], ['69', '69,7']].map((x) => '<tr><td>' + x[0] + '</td><td>' + x[1] + ' mm</td></tr>').join('') + '</table></details>' : '';
      c.innerHTML = pal + '<div class="tir-lignes">' + lignes + '</div>' + guide + tot + btns + '<div class="tir-reco" data-tir-reco></div>';

      const dans = new Set(cart.items.map((i) => i.product_id));
      const liste = (await produits()).filter((p) => !dans.has(p.id) && !p.options.some((o) => /taille/i.test(o.name)) && p.variants.some((v) => v.available)).slice(0, 3);
      const reco = c.querySelector('[data-tir-reco]');
      if (!liste.length || !reco) return;
      reco.innerHTML = '<div class="tir-rt">' + (n < 3 ? 'Complète ton pack' : 'Continue ta collection') + '</div><div class="tir-rg">' + liste.map((p) => {
        const vs = p.variants.filter((v) => v.available);
        return '<form class="tir-r" data-tir-ajout>' +
          '<a href="' + racine + 'products/' + p.handle + '"><img src="' + img((p.images[0] || {}).src, 300) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
          '<a class="n" href="' + racine + 'products/' + p.handle + '">' + esc(p.title) + '</a><span class="pr">' + euro(Math.round(parseFloat(vs[0].price) * 100)) + '</span>' +
          (vs.length > 1 ? '<div class="pas">' + vs.map((v, i) => '<label title="' + esc(v.option1) + '"><input type="radio" name="id" value="' + v.id + '"' + (i ? '' : ' checked') + '><i style="background:' + pastille(v.option1) + '"></i><span class="visually-hidden">' + esc(v.option1) + '</span></label>').join('') + '</div>'
            : '<input type="hidden" name="id" value="' + vs[0].id + '">') +
          '<input type="hidden" name="quantity" value="1"><button type="submit">+ Ajouter</button></form>';
      }).join('') + '</div>';
    };

    const maj = (cart, ajoute) => {
      document.querySelectorAll('[data-cart-count]').forEach((x) => x.textContent = cart.item_count);
      return dessiner(cart, ajoute);
    };
    const ouvrir = async (ajoute) => {
      try { await maj(await (await fetch(window.routes.cart_url + '.js')).json(), ajoute); } catch (x) { location.href = window.routes.cart_url; return; }
      t.classList.add('on'); t.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('tir-ouvert');
      const z = document.querySelector('[data-mp-zone]'); if (z) z.classList.remove('on');
      t.querySelector('.tir-x').focus({ preventScroll: true });
    };
    window.cmTiroir = ouvrir;

    c.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-tir-q]'); if (!b) return;
      b.disabled = true;
      const r = await fetch(racine + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: b.dataset.tirQ, quantity: +b.dataset.n }) });
      maj(await r.json(), false);
    });
    c.addEventListener('click', (e) => {
      const b = e.target.closest('[data-tir-pc]'); if (!b || b.disabled || b.classList.contains('on')) return;
      const box = b.closest('[data-tir-var]'); box.dataset.val = b.dataset.tirPc; changer(box);
    });
    c.addEventListener('change', (e) => { const s = e.target.closest('[data-tir-var]'); if (s) changer(s); });
    const changer = async (s) => {
      const l = s.closest('.tir-l'), p = await fiche(s.dataset.h); if (!p) return;
      const vals = Array.from(l.querySelectorAll('[data-tir-var]')).sort((a, b) => a.dataset.i - b.dataset.i).map((x) => x.tagName === 'SELECT' ? x.value : x.dataset.val);
      const v = p.variants.find((x) => x.options.every((y, j) => y === vals[j]));
      if (!v || !v.available) return;
      l.classList.add('maj');
      try {
        await fetch(racine + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: s.dataset.tirVar, quantity: 0 }) });
        await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: +s.dataset.qte || 1 }] }) });
      } catch (x) {}
      maj(await (await fetch(window.routes.cart_url + '.js')).json(), false);
      document.dispatchEvent(new CustomEvent('cm:panier'));
    };
    const codesActuels = async () => ((await (await fetch(window.routes.cart_url + '.js')).json()).discount_codes || []).map((x) => x.code);
    const poserCodes = async (liste) => {
      const r = await fetch(racine + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: liste.join(',') }) });
      maj(await r.json(), false); document.dispatchEvent(new CustomEvent('cm:panier'));
    };
    c.addEventListener('submit', async (e) => {
      const f = e.target.closest('[data-tir-code]'); if (!f) return;
      e.preventDefault();
      const code = f.code.value.trim().toUpperCase(); if (!code) return;
      f.querySelector('button').textContent = '…';
      const deja = await codesActuels();
      poserCodes(deja.filter((x) => x.toUpperCase() !== code).concat(code));
    });
    c.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-tir-sans]'); if (!b) return;
      const deja = await codesActuels();
      poserCodes(deja.filter((x) => x.toUpperCase() !== b.dataset.tirSans.toUpperCase()));
    });
    c.addEventListener('submit', async (e) => {
      const f = e.target.closest('[data-tir-ajout]'); if (!f) return;
      e.preventDefault();
      const b = f.querySelector('button'); b.disabled = true; b.textContent = '…';
      await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) });
      ouvrir(true);
    });

    // le lien « Panier » de l'en-tête ouvre aussi le tiroir
    document.querySelectorAll('[data-mp-zone] > a').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); ouvrir(false); }));
  })();

  // cartes produits : ajout rapide au panier, puis le tiroir s'ouvre
  const stc = document.createElement('style');
  stc.textContent = '.cm-bs-c{position:absolute;top:10px;left:10px;z-index:2;background:#151515;color:#fff;font:700 10.5px \'Space Mono\',monospace;text-transform:uppercase;padding:4px 8px}' +
    '.ligne.cm-l{align-items:center}.cm-mvt-c{background:#FFF4D8;color:#151515;font:700 10.5px \'Space Mono\',monospace;text-transform:uppercase;padding:3px 8px;white-space:nowrap}.cm-l b{font:700 15px \'Space Mono\',monospace}';
  document.head.appendChild(stc);
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-cm-qa]'); if (!b) return;
    e.preventDefault(); const txt = b.textContent; b.disabled = true; b.textContent = '…';
    try {
      const r = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.cmQa, quantity: 1 }] }) });
      if (!r.ok) throw r;
      b.textContent = '✓';
      if (window.cmTiroir) window.cmTiroir(true);
    } catch (x) { b.textContent = 'Indisponible'; }
    setTimeout(() => { b.disabled = false; b.textContent = txt; }, 1800);
  });

  // guide des tailles
  document.querySelectorAll('[data-ouvrir-tailles]').forEach((b) => b.addEventListener('click', () => document.getElementById('guide-tailles').showModal()));
  document.querySelectorAll('[data-fermer-dialog]').forEach((b) => b.addEventListener('click', () => b.closest('dialog').close()));
})();
